import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import _ = require('underscore');
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { ClassificationCategoriesService } from '../../../../../app.retailer.common/modules/categories/classification-categories.service';
import { CategoriesSelectorService } from '../../../categories/categoriesSelector.service';
import { IRetailerRootScope } from '../../../core/models';
import { NfcRetailerStickersService } from '../../nfc-retailer-stickers.service';
import { IChoiceClassificationCategoriesOptions } from '../../shared/select-product-category/select-product-category.component';


class WizardProductsStep implements ng.IController {
    static $inject = ['$scope', '$translate', '$uibModal', '$rootScope', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService'];

    selectedProductsAndCategories: any[] = [];
    isAllProductsSelected: boolean;
    isAllCategoriesSelected: boolean;
    listHeader: string;
    itemsNotSelected: string;

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        public $rootScope: IRetailerRootScope,
        protected categoriesSelectorService: CategoriesSelectorService,
        public classificationCategoriesService: ClassificationCategoriesService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService
    ) {
    }

    $onInit(): void {
        this.listHeader = this.$translate.instant('nfc_wizard_products_step_list_header');
        this.itemsNotSelected = this.$translate.instant('nfc_wizard_products_step_not_selected');
    }

    addProduct = async () => {
        let selectedProducts = this.selectedProductsAndCategories.filter(x => x.hasOwnProperty('Title'));

        let operationResult: any;

        try {
            operationResult = await this.$uibModal.open({
                component: 'selectProducts',
                resolve: {
                    options: () => {
                        return {
                            selectedProducts: selectedProducts,
                            isAllSelected: this.isAllProductsSelected
                        };
                    }
                },
                size: 'md',
                backdrop: 'static',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult && operationResult.status !== 'ok') {
            return;
        }

        if (operationResult && operationResult.isAllSelected) {
           this.isAllProductsSelected = true;
            this.nfcRetailerStickersService.getAllProducts()
                .then(allProducts => {
                    return this.updateProductsOrCategories(allProducts, 'ID');
                })
                .catch(error => this.notificationService.showErrorMessage(error));
            return;
        }

        this.isAllProductsSelected = false;
        this.updateProductsOrCategories(operationResult.selectedProducts, 'ID');
    }

    updateProductsOrCategories = (items: any, idFieldName: string) => {
        let currentItems = this.selectedProductsAndCategories;
        let changedItemsMap = _.indexBy(items, idFieldName);
        for (let i = currentItems.length - 1; i >= 0; i--) {
            let currentItem = currentItems[i];
            if (!currentItem.hasOwnProperty(idFieldName)) {
                continue;
            }

            if (changedItemsMap[currentItem[idFieldName]]) {
                delete changedItemsMap[currentItem[idFieldName]];
            } else {
                currentItems.splice(i, 1);
            }
        }
        let itemsToAdd = _.map(changedItemsMap, i => i);
        itemsToAdd.forEach(item => currentItems.push(item));
    }

    addCategory = async () => {

        let selectedCategories = this.selectedProductsAndCategories.filter(x => x.hasOwnProperty('CategoryFullName'));

        let operationResult: any;
        try {
            operationResult = await this.$uibModal.open({
                component: 'selectProductCategory',
                resolve: {
                    options: (): IChoiceClassificationCategoriesOptions => {
                        return {
                            singleSelect: false,
                            selectedCategories: selectedCategories,
                            businessType: this.$rootScope.enums.BusinessType.All,
                            isOnlyStoreCategories: false,
                            needAllSelect: false,
                            isAllSelected: angular.copy(this.isAllCategoriesSelected),
                            getCategoriesTree: async () => {
                                return await this.nfcRetailerStickersService.getClassificationCategoriesForRetailer();
                            }
                        };
                    }
                },
                size: 'lg',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult && operationResult.status !== 'ok') {
            return;
        }

        if (operationResult && operationResult.isAllSelected) {
            this.isAllCategoriesSelected = true;
            return;
        }

        this.isAllCategoriesSelected = false;
        this.updateProductsOrCategories(operationResult.selectedCategories, 'CategoryID');
    }

    deleteItem = (item: any) => {
        let index = this.selectedProductsAndCategories.indexOf(item);
        this.selectedProductsAndCategories.splice(index, 1);
        if (item.ID) {
            this.isAllProductsSelected = false;
        }
    }
}

angular.module('naut').component('wizardProductsStep', {
    template: require('./wizard-products-step.component.html'),
    controller: WizardProductsStep,
    controllerAs: 'ctrl',
    bindings: {
        selectedProductsAndCategories: '=',
        isAllProductsSelected: '=',
        isAllCategoriesSelected: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/wizard-products-step/wizard-products-step.component.ts